module.exports = __webpack_public_path__ + "img/type-style7.bb4b0084.png";